import { Box, Stack } from '@mui/material';
import React from 'react';
import {Link, useLocation,Outlet} from 'react-router-dom';
const Category=()=>{
  const location=useLocation();
  const isActive=(path: string)=>location.pathname.endsWith(path);
  const buttonstyle={
    dispaly:'inline-block',
    padding:'5px 20px',
    backgroundColor:'#007bff',
    color:'white',
    textDecoration:'none',
    borderRadius:'5px',
    fontsize:'16px',
  };
  const activeButtonStyle={
    ...buttonstyle,
    backgroundColor:"#0056b3",
    fontWeight:'bold'
  }

return(<div>
<Box sx={{position:'absolute',top:'60px',left:0,width:'100%',display:'flex',justifyContent:'center',zIndex:1000,marginBottom:'0px'}}>
  <Stack direction="row" spacing={2}>
   <Link to="main" style={isActive('main')?activeButtonStyle:buttonstyle}>Category</Link>       
   <Link to="sub" style={isActive('sub')?activeButtonStyle:buttonstyle}>Sub Category</Link>
  </Stack>
  </Box>
  <Outlet/>

</div>);

};

export default Category;